"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatApiUrl = formatApiUrl;
exports.sendCustomRequest = sendCustomRequest;
exports.sendDeleteRequest = sendDeleteRequest;
exports.sendFormRequest = sendFormRequest;
exports.sendPatchRequest = sendPatchRequest;
exports.sendPostRequest = sendPostRequest;
exports.sendPostRequestRaw = sendPostRequestRaw;
exports.sendPutRequest = sendPutRequest;
exports.sendRawRequest = sendRawRequest;
exports.sendRequest = sendRequest;
exports.sendUploadRequest = sendUploadRequest;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var REACT_APP_API_URL = process.env.REACT_APP_API_URL;
var ERROR_NETWORK_MSG = 'Network Error';
function handleCommonResponse(_x) {
  return _handleCommonResponse.apply(this, arguments);
}
function _handleCommonResponse() {
  _handleCommonResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
    var result, _result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!response.ok) {
            _context.next = 13;
            break;
          }
          _context.prev = 1;
          _context.next = 4;
          return response.json();
        case 4:
          result = _context.sent;
          return _context.abrupt("return", {
            success: true,
            data: result
          });
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", {
            success: true,
            data: null
          });
        case 11:
          _context.next = 24;
          break;
        case 13:
          if (!(response.status === 400)) {
            _context.next = 24;
            break;
          }
          _context.prev = 14;
          _context.next = 17;
          return response.json();
        case 17:
          _result = _context.sent;
          return _context.abrupt("return", {
            success: false,
            data: _result
          });
        case 21:
          _context.prev = 21;
          _context.t1 = _context["catch"](14);
          return _context.abrupt("return", {
            success: false,
            data: null
          });
        case 24:
          throw new Error('Network Error');
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8], [14, 21]]);
  }));
  return _handleCommonResponse.apply(this, arguments);
}
function sendUploadRequest(_x2, _x3) {
  return _sendUploadRequest.apply(this, arguments);
}
function _sendUploadRequest() {
  _sendUploadRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(path, data) {
    var options,
      url,
      headers,
      authToken,
      response,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = options.headers || new Headers();
          authToken = options.authToken;
          if (authToken) {
            headers.append('Authorization', "Bearer ".concat(authToken));
          }
          _context2.next = 7;
          return fetch(url, {
            method: 'PUT',
            body: data,
            headers: headers,
            credentials: 'include'
          });
        case 7:
          response = _context2.sent;
          return _context2.abrupt("return", handleCommonResponse(response));
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _sendUploadRequest.apply(this, arguments);
}
function sendRequest(_x4, _x5) {
  return _sendRequest.apply(this, arguments);
}
function _sendRequest() {
  _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(path, options) {
    var url, headers, authToken, response, _yield$response$json, data, body, content;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = options.headers || new Headers();
          authToken = options.authToken;
          if (authToken) {
            headers.append('Authorization', "Bearer ".concat(authToken));
          }
          _context3.next = 6;
          return fetch(url, {
            method: 'GET',
            headers: headers,
            credentials: 'include'
          });
        case 6:
          response = _context3.sent;
          if (!response.ok) {
            _context3.next = 21;
            break;
          }
          _context3.prev = 8;
          _context3.next = 11;
          return response.json();
        case 11:
          _yield$response$json = _context3.sent;
          data = _yield$response$json.data;
          body = _yield$response$json.body;
          content = _yield$response$json.content;
          return _context3.abrupt("return", {
            success: true,
            data: data,
            body: body,
            content: content,
            response: response
          });
        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](8);
          return _context3.abrupt("return", {
            success: true,
            data: null,
            body: null,
            content: null,
            response: response
          });
        case 21:
          throw new Error('Error in request');
        case 22:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[8, 18]]);
  }));
  return _sendRequest.apply(this, arguments);
}
function sendRawRequest(_x6, _x7) {
  return _sendRawRequest.apply(this, arguments);
}
function _sendRawRequest() {
  _sendRawRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(path, options) {
    var url, headers, authToken, response, data;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = options.headers || new Headers();
          authToken = options.authToken;
          if (authToken) {
            headers.append('Authorization', "Bearer ".concat(authToken));
          }
          _context4.next = 6;
          return fetch(url, {
            method: 'GET',
            headers: headers,
            credentials: 'include'
          });
        case 6:
          response = _context4.sent;
          if (!response.ok) {
            _context4.next = 18;
            break;
          }
          _context4.prev = 8;
          _context4.next = 11;
          return response.json();
        case 11:
          data = _context4.sent;
          return _context4.abrupt("return", {
            success: true,
            data: data
          });
        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4["catch"](8);
          return _context4.abrupt("return", {
            success: false,
            data: _context4.t0
          });
        case 18:
          throw new Error('Error in request');
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[8, 15]]);
  }));
  return _sendRawRequest.apply(this, arguments);
}
function sendPostRequestRaw(_x8, _x9) {
  return _sendPostRequestRaw.apply(this, arguments);
}
function _sendPostRequestRaw() {
  _sendPostRequestRaw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(path, data) {
    var options,
      url,
      headers,
      authToken,
      response,
      _headers,
      body,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = new Headers();
          headers.append('content-type', 'application/json');
          authToken = options.authToken;
          if (authToken) {
            headers.append('Authorization', "Bearer ".concat(authToken));
          }
          _context5.next = 8;
          return fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data),
            credentials: 'include'
          });
        case 8:
          response = _context5.sent;
          if (!response.ok) {
            _context5.next = 20;
            break;
          }
          _context5.prev = 10;
          _headers = response.headers, body = response.body;
          return _context5.abrupt("return", {
            success: true,
            data: {
              headers: _headers,
              body: body
            }
          });
        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5["catch"](10);
          return _context5.abrupt("return", {
            success: true,
            data: null
          });
        case 18:
          _context5.next = 22;
          break;
        case 20:
          if (!(response.status === 400)) {
            _context5.next = 22;
            break;
          }
          return _context5.abrupt("return", {
            success: false,
            data: null
          });
        case 22:
          throw new Error('Network Error');
        case 23:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[10, 15]]);
  }));
  return _sendPostRequestRaw.apply(this, arguments);
}
function sendPostRequest(_x10, _x11, _x12) {
  return _sendPostRequest.apply(this, arguments);
}
function _sendPostRequest() {
  _sendPostRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(path, data, options) {
    var url, headers, authToken, response, result, _result2;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = options.headers || new Headers();
          headers.append('content-type', 'application/json');
          authToken = options.authToken;
          if (authToken) {
            headers.append('Authorization', "Bearer ".concat(authToken));
          }
          _context6.next = 7;
          return fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data),
            credentials: 'include'
          });
        case 7:
          response = _context6.sent;
          if (!response.ok) {
            _context6.next = 21;
            break;
          }
          _context6.prev = 9;
          _context6.next = 12;
          return response.json();
        case 12:
          result = _context6.sent;
          return _context6.abrupt("return", {
            success: true,
            data: result
          });
        case 16:
          _context6.prev = 16;
          _context6.t0 = _context6["catch"](9);
          return _context6.abrupt("return", {
            success: true,
            data: null,
            error: _context6.t0
          });
        case 19:
          _context6.next = 32;
          break;
        case 21:
          if (!(response.status === 400)) {
            _context6.next = 32;
            break;
          }
          _context6.prev = 22;
          _context6.next = 25;
          return response.json();
        case 25:
          _result2 = _context6.sent;
          return _context6.abrupt("return", {
            success: false,
            data: _result2
          });
        case 29:
          _context6.prev = 29;
          _context6.t1 = _context6["catch"](22);
          return _context6.abrupt("return", {
            success: false,
            data: null,
            error: _context6.t1
          });
        case 32:
          throw new Error('Network Error');
        case 33:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[9, 16], [22, 29]]);
  }));
  return _sendPostRequest.apply(this, arguments);
}
function sendFormRequest(_x13, _x14, _x15) {
  return _sendFormRequest.apply(this, arguments);
}
function _sendFormRequest() {
  _sendFormRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(path, data, options) {
    var url, headers, authToken, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = new Headers();
          authToken = options.authToken;
          if (authToken) {
            headers.append('Authorization', "Bearer ".concat(authToken));
          }
          _context7.next = 6;
          return fetch(url, {
            method: 'POST',
            headers: headers,
            body: data
          });
        case 6:
          response = _context7.sent;
          return _context7.abrupt("return", handleCommonResponse(response));
        case 8:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _sendFormRequest.apply(this, arguments);
}
function sendPutRequest(_x16, _x17, _x18) {
  return _sendPutRequest.apply(this, arguments);
}
function _sendPutRequest() {
  _sendPutRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(path, data, options) {
    var url, headers, response, result, _result3;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          headers = options.headers || new Headers();
          headers.append('content-type', 'application/json');
          if (options.authToken) {
            headers.append('authorization', "Bearer ".concat(options.authToken));
          }
          _context8.next = 6;
          return fetch(url, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(data),
            credentials: 'include'
          });
        case 6:
          response = _context8.sent;
          if (!response.ok) {
            _context8.next = 20;
            break;
          }
          _context8.prev = 8;
          _context8.next = 11;
          return response.json();
        case 11:
          result = _context8.sent;
          return _context8.abrupt("return", {
            success: true,
            data: result
          });
        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](8);
          return _context8.abrupt("return", {
            success: true,
            data: null
          });
        case 18:
          _context8.next = 31;
          break;
        case 20:
          if (!(response.status === 400)) {
            _context8.next = 31;
            break;
          }
          _context8.prev = 21;
          _context8.next = 24;
          return response.json();
        case 24:
          _result3 = _context8.sent;
          return _context8.abrupt("return", {
            success: false,
            data: _result3
          });
        case 28:
          _context8.prev = 28;
          _context8.t1 = _context8["catch"](21);
          return _context8.abrupt("return", {
            success: false,
            data: null
          });
        case 31:
          return _context8.abrupt("return", {
            data: null,
            success: false
          });
        case 32:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[8, 15], [21, 28]]);
  }));
  return _sendPutRequest.apply(this, arguments);
}
function sendPatchRequest(_x19, _x20, _x21) {
  return _sendPatchRequest.apply(this, arguments);
}
function _sendPatchRequest() {
  _sendPatchRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(path, data, options) {
    var url, response, headers;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          _context9.next = 3;
          return fetch(url, {
            method: 'PATCH',
            headers: options.headers || new Headers(),
            body: JSON.stringify(data),
            credentials: 'include'
          });
        case 3:
          response = _context9.sent;
          headers = options.headers || new Headers();
          headers.append('content-type', 'application/json');
          if (options.authToken) {
            headers.append('authorization', "Bearer ".concat(options.authToken));
          }
          return _context9.abrupt("return", handleCommonResponse(response));
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _sendPatchRequest.apply(this, arguments);
}
function sendDeleteRequest(_x22, _x23) {
  return _sendDeleteRequest.apply(this, arguments);
}
function _sendDeleteRequest() {
  _sendDeleteRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(path, options) {
    var headers, url, response, _yield$response$json2, data;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          headers = options.headers || new Headers();
          headers.append('content-type', 'application/json');
          if (options.authToken) {
            headers.append('authorization', "Bearer ".concat(options.authToken));
          }
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          _context10.next = 6;
          return fetch(url, {
            method: 'DELETE',
            headers: headers,
            credentials: 'include'
          });
        case 6:
          response = _context10.sent;
          if (!response.ok) {
            _context10.next = 19;
            break;
          }
          _context10.prev = 8;
          _context10.next = 11;
          return response.json();
        case 11:
          _yield$response$json2 = _context10.sent;
          data = _yield$response$json2.data;
          return _context10.abrupt("return", {
            success: true,
            data: data
          });
        case 16:
          _context10.prev = 16;
          _context10.t0 = _context10["catch"](8);
          return _context10.abrupt("return", {
            success: true,
            data: null
          });
        case 19:
          throw new Error('Error in request');
        case 20:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[8, 16]]);
  }));
  return _sendDeleteRequest.apply(this, arguments);
}
function formatApiUrl(path) {
  return "".concat(REACT_APP_API_URL, "/").concat(path);
}
function sendCustomRequest(_x24, _x25, _x26) {
  return _sendCustomRequest.apply(this, arguments);
}
function _sendCustomRequest() {
  _sendCustomRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(path, options, data) {
    var method,
      headers,
      url,
      response,
      json,
      _args11 = arguments;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          method = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : 'get';
          headers = options.headers || new Headers();
          headers.append('content-type', 'application/json');
          if (options.authToken) {
            headers.append('authorization', "Bearer ".concat(options.authToken));
          }
          url = "".concat(REACT_APP_API_URL, "/").concat(path);
          _context11.next = 7;
          return fetch(url, {
            method: method,
            headers: headers,
            body: data ? JSON.stringify(data) : undefined,
            credentials: 'include'
          });
        case 7:
          response = _context11.sent;
          _context11.next = 10;
          return response.json();
        case 10:
          json = _context11.sent;
          return _context11.abrupt("return", {
            data: json,
            success: response.ok,
            status: response.status
          });
        case 12:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _sendCustomRequest.apply(this, arguments);
}